// Build-time environment constants injected by Vite
export const IS_DEVELOPMENT: boolean = __IS_DEVELOPMENT__;

export const IS_TESTING: boolean = __IS_TEST__ || __IS_STAGING__;

// A seeded stack serves the app in `local-development`, which none of the
// listed modes cover, so the e2e window hooks also honour the explicit
// `VITE_E2E_TESTS` opt-in every e2e env file already sets.
export const IS_E2E_TESTS_ENV: boolean =
  __IS_DEVELOPMENT__ ||
  __IS_TEST__ ||
  __IS_STAGING__ ||
  __IS_DEVELOP__ ||
  import.meta.env.VITE_E2E_TESTS === 'true';

export const IS_PRODUCTION: boolean = __IS_PRODUCTION__ || __IS_DEVELOP__;

export const CURRENCY = '€';

export const AMAZON_URL = 'https://s3.eu-west-2.amazonaws.com/ifeel-media';

export const CDN_URL = 'https://ifeel-media.s3.eu-west-2.amazonaws.com';

export const ASSETS_URL = 'https://app.ifeelonline.com/assets';

export const LOCALE_PREFERRED_COOKIE = 'locale-preferred';

export const GTM_ID = 'GTM-NQLRMVM2';
